import React from 'react';
import tinycolor from 'tinycolor2';
import styles from './ProgramGroupMessage.module.scss';

function ProgramGroupMessage(props) {
    const { event, children, onClick } = props;

    return (
        <div
            className={[styles.ProgramGroupMessage, onClick ? 'clickable' : ''].join(' ')}
            onClick={onClick}
            style={{
                backgroundColor: tinycolor(event.settings.secondary_color).lighten().toString(),
            }}>
            {children}
        </div>
    );
}

export default ProgramGroupMessage;
